import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.component.style.scss';

import { ReactComponent as CalendarIcon } from '../../../../_shared/assets/svg/calendar-solid.svg';

import moment from 'moment';

export interface ICalendarProps {
    value?: Date | string;
    selected?: Date;
    identifier: string;
    onChange: (e: Date) => void;
    maxDate?: Date;
    minDate?: Date;
}

export const Calendar: React.FC<ICalendarProps> = ({ value, selected, onChange, maxDate, minDate }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <div>
            <DatePicker
                onChange={(date) => {
                    onChange(date as Date)
                    console.log(date);
                }}
                className='datepicker-input'
                autoComplete='off'
                // selected={value ? new Date(value) : new Date()}
                selected={selected}
                dateFormat='dd/MM/yyyy'
                value={selected ? moment(selected).format('DD/MM/YYYY') : ''}
                // open={isOpen}
                // showTimeSelect
                // onFocus={() => setIsOpen(true)}
                // onSelect={() => setIsOpen(false)}
                maxDate={maxDate ?? undefined}
                minDate={minDate ?? undefined}
                onClickOutside={() => setIsOpen(false)}
            />
            <div className='calendar-icon d-flex justify-content-center align-items-center'>
                <CalendarIcon fill='#ff4949' width='inherit' height='inherit' onClick={() => setIsOpen(true)} />
            </div>
        </div>
    );
};
